import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from '@mui/material';
import axios from 'axios';
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { showTableResponse } from '../common-helpers/commonServices';
import NEET_ArticlesModal from './NEET_ArticlesModal';
import swal from 'sweetalert';

const ArticleTable = ({ title, data, articles, handleDeleteArticle, childRef, handleMoveOrder, searchTerm }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 50;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = data?.slice(firstIndex, lastIndex) || [];
    const npage = Math.ceil((data?.length || 0) / pageSize);
    const number = [...Array(npage + 1).keys()].slice(1);

    const handlePageChange = (e, p) => {
        setCurrentPage(parseInt(p));
    };

    return (
        <div className="card mt-2 mb-4">
            <div className="card-header bg-light d-flex justify-content-between align-items-center p-3">
                <h4 className="mb-0 card-title text-primary" style={{ fontSize: "16px", fontWeight: "bold" }}>{title}</h4>
                <div className="d-flex align-items-center">
                    <div className='dataTables_info text-dark me-3' style={{ fontSize: "14px" }}>
                        Records: {data.length}
                    </div>
                    {number.length > 1 && (
                        <div className="dataTables_paginate paging_simple_numbers mb-0">
                            <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={handlePageChange} />
                        </div>
                    )}
                </div>
            </div>
            <div className="card-body p-0">
                <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                    <div className="dataTables_wrapper no-footer">
                        <table className="table-responsive-lg table display dataTablesCard student-tab dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }}>
                            <thead style={{ backgroundColor: "#cccccc" }}>
                                <tr className='text-center text-dark border border-left'>
                                    <th className=' custom-table-header p-2'>Sl.No.</th>
                                    <th className='p-2  custom-table-header text-center '>ORDER</th>
                                    <th className='p-2 custom-table-header text-start'>TITLE</th>
                                    <th className='p-2 custom-table-header text-start'>TYPE</th>
                                    <th className=' custom-table-header p-2'>ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {records.length > 0 ? records.map((item, ind) => (
                                    <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`}>
                                        <td className='text-center p-1 column-width' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                            <h6 className="text-primary mb-0">{ind + 1 + firstIndex}</h6>
                                        </td>
                                        <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "120px" }}>
                                            <div className="d-flex align-items-center justify-content-center">
                                                <FaArrowUp
                                                    className={`me-2 ${ (ind + firstIndex === 0) ? 'text-light' : 'text-primary'}`}
                                                    style={{ cursor: (ind + firstIndex === 0) ? 'default' : 'pointer' }}
                                                    onClick={() => handleMoveOrder(item.Type, ind, 'up')}
                                                />
                                                <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold', width: '20px' }}>{item.DisplayOrder || 0}</h6>
                                                <FaArrowDown
                                                    className={`ms-2 ${ (ind + firstIndex === data.length - 1) ? 'text-light' : 'text-primary'}`}
                                                    style={{ cursor: (ind + firstIndex === data.length - 1) ? 'default' : 'pointer' }}
                                                    onClick={() => handleMoveOrder(item.Type, ind, 'down')}
                                                />
                                            </div>
                                        </td>
                                        <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                            <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Title}</h6>
                                        </td>
                                        <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "150px" }}>
                                            {(() => {
                                                let badgeClass = 'badge-primary';
                                                if (item.Type === 'Latest Developments') {
                                                    badgeClass = 'badge-success';
                                                } else if (item.Type === 'Articles') {
                                                    badgeClass = 'badge-primary';
                                                } else {
                                                    const badgeClasses = ['badge-primary', 'badge-info', 'badge-success', 'badge-warning', 'badge-danger', 'badge-dark'];
                                                    const hash = item.Type ? item.Type.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) : 0;
                                                    badgeClass = badgeClasses[hash % badgeClasses.length];
                                                }
                                                return <span className={`badge badge-sm ${badgeClass}`}>{item.Type}</span>;
                                            })()}
                                        </td>
                                        <td className="p-1 text-center" style={{ border: "1px solid #ccc", width: "100px" }}>
                                            <CiEdit cursor='pointer' title='Edit Article' size={20} className='text-primary me-2' onClick={() => childRef.current.openModal(item)} />
                                            <MdDeleteOutline color="red" title='Delete Article' cursor='pointer' size={20} onClick={() => { handleDeleteArticle(item.Sn) }} />
                                        </td>
                                    </tr>
                                )) :
                                    <tr>
                                        <td colSpan="5" className="text-center">
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                {showTableResponse(articles, data)}
                                            </div>
                                        </td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

const NEET_Articles = () => {
    const childRef = useRef();
    const [articles, setArticles] = useState([]);
    const [filteredArticles, setFilteredArticles] = useState([]);
    const [loadArticles, setArticleLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const filtered = articles?.filter(
            item => item?.Title?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
                item?.Type?.toLowerCase().includes(searchTerm?.toLowerCase())
        );
        setFilteredArticles(filtered)
    }, [searchTerm, articles])

    const handleSearch = (e) => {
        setSearchTerm(e.target.value)
    }

    const handleMoveOrder = async (type, index, direction) => {
        if (searchTerm) {
            toast.warning("Please clear search before reordering");
            return;
        }

        // Filter the list to only include the relevant type
        const sameTypeArticles = articles.filter(a => a.Type === type);
        const otherTypeArticles = articles.filter(a => a.Type !== type);
        
        const targetIndex = direction === 'up' ? index - 1 : index + 1;

        if (targetIndex < 0 || targetIndex >= sameTypeArticles.length) return;

        // Swap items in the same-type list
        const updatedSameType = [...sameTypeArticles];
        [updatedSameType[index], updatedSameType[targetIndex]] = [updatedSameType[targetIndex], updatedSameType[index]];

        // Update DisplayOrder for the same-type list
        const sequentiallyOrdered = updatedSameType.map((item, idx) => ({
            ...item,
            DisplayOrder: idx + 1
        }));

        // Combine back with other types
        const combined = [...sequentiallyOrdered, ...otherTypeArticles];
        setArticles(combined);

        // Prepare data for backend
        const orderData = sequentiallyOrdered.map(item => ({
            Sn: item.Sn,
            DisplayOrder: item.DisplayOrder
        }));

        try {
            await axios.post(BACKEND_SERVER_URL + '/neet/updateArticleOrder', orderData);
            toast.success("Order updated");
        } catch (error) {
            console.error("Error updating order:", error);
            toast.error("Failed to update order");
            setArticleLoading(!loadArticles);
        }
    };

    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/neet/articles').then((res) => {
            let data = res.data.data;
            setArticles(data);
            setFilteredArticles(data);
        }).catch((error) => {
            console.log(error)
            toast.error("Error fetching articles");
        })
    }, [loadArticles])

    const handleDeleteArticle = (id) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this article!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                axios.delete(BACKEND_SERVER_URL + `/neet/deleteArticle/${id}`).then((res) => {
                    toast.success(res.data.message);
                    setArticleLoading(!loadArticles);
                }).catch((error) => {
                    toast.error("Error deleting article");
                })
            }
        });
    }

    const articlesData = filteredArticles.filter(a => a.Type === 'Articles');
    const developmentsData = filteredArticles.filter(a => a.Type === 'Latest Developments');

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">
                                <div className=' col-8 d-flex justify-content-between'>
                                    <div className="col-sm-4">
                                        <button type="button" className="btn btn-dark btn-sm me-2"
                                            onClick={() => childRef.current.openModal()}
                                        >
                                            + Add NEET Article
                                        </button>
                                    </div>
                                </div>

                                <div className="input-group search-area mb-md-0 mb-3">
                                    <input type="text" className="form-control" onChange={handleSearch} value={searchTerm} placeholder="Search here..." />
                                    <span className="input-group-text"><Link to={"#"}>
                                        <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5605 15.4395L13.7527 11.6317C14.5395 10.446 15 9.02625 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C9.02625 15 10.446 14.5395 11.6317 13.7527L15.4395 17.5605C16.0245 18.1462 16.9755 18.1462 17.5605 17.5605C18.1462 16.9747 18.1462 16.0252 17.5605 15.4395V15.4395ZM2.25 7.5C2.25 4.605 4.605 2.25 7.5 2.25C10.395 2.25 12.75 4.605 12.75 7.5C12.75 10.395 10.395 12.75 7.5 12.75C4.605 12.75 2.25 10.395 2.25 7.5V7.5Z" fill="#01A3FF" />
                                        </svg>
                                    </Link></span>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-12">
                            <ArticleTable 
                                title="Articles" 
                                data={articlesData} 
                                articles={articles} 
                                handleDeleteArticle={handleDeleteArticle} 
                                childRef={childRef} 
                                handleMoveOrder={handleMoveOrder}
                                searchTerm={searchTerm}
                            />
                            
                            <ArticleTable 
                                title="Latest Developments" 
                                data={developmentsData} 
                                articles={articles} 
                                handleDeleteArticle={handleDeleteArticle} 
                                childRef={childRef} 
                                handleMoveOrder={handleMoveOrder}
                                searchTerm={searchTerm}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <NEET_ArticlesModal ref={childRef} loadArticles={loadArticles} setArticleLoading={setArticleLoading} />
        </>
    )
}

export default NEET_Articles;
